let errorObserver = null;

function findApplyButton(shadow) {
  return (
    shadow.querySelector(".cd-discount-button") ||
    shadow.querySelector(".opus-btn-apply")
  );
}

function findCheckoutButton(shadow) {
  return (
    shadow.querySelector(".cd-checkout-section-button") ||
    shadow.querySelector(".opus-btn-checkout button")
  );
}

function findDiscountInput(shadow) {
  return (
    shadow.querySelector(".opus-discount-input") ||
    shadow.querySelector('input[name="discount"]')
  );
}

function clearCouponError() {
  if (errorObserver) {
    errorObserver.disconnect();
    errorObserver = null;
  }

  const shadowHost = document.getElementById("opus-shadow-container");
  if (!shadowHost?.shadowRoot) return;

  const errorEl = shadowHost.shadowRoot.querySelector(".coupon-error-message");
  if (errorEl) {
    errorEl.remove();
  }
}

function showCouponError(message) {
  const shadowHost = document.getElementById("opus-shadow-container");
  if (!shadowHost?.shadowRoot) return;

  const shadow = shadowHost.shadowRoot;
  const discountInput = shadow.querySelector(".opus-discount-input");
  if (!discountInput) return;

  if (discountInput) {
    discountInput.value = "";
    discountInput.dispatchEvent(new Event("input", { bubbles: true }));
  }

  // remove existing error
  clearCouponError();

  const errorEl = document.createElement("div");
  errorEl.className = "coupon-error-message";
  errorEl.textContent = message;
  errorEl.style.cssText = `
                color: #dc2626;
                font-size: 12px;
                margin-top: 4px;
                font-family: var(--font-primary-regular), sans-serif;
            `;

  function insertError() {
    const checkoutSection = shadow.querySelector(
      ".cd-checkout-section-container",
    );
    if (checkoutSection && errorEl.nextElementSibling !== checkoutSection) {
      checkoutSection.insertAdjacentElement("beforebegin", errorEl);
    }
  }

  insertError();

  const bottomSection = shadow.querySelector(".bottom-section");
  if (bottomSection) {
    errorObserver = new MutationObserver(() => {
      const existingError = shadow.querySelector(".coupon-error-message");
      if (existingError) {
        insertError();
      }
    });
    errorObserver.observe(bottomSection, { childList: true, subtree: true });
  }

  discountInput.addEventListener("focus", () => clearCouponError(), {
    once: true,
  });
}

async function verifyCouponLogic(discountCode) {
  const COUPON_ERRORS = {
    INVALID: window.cartCouponWarningText.invalid,
    EXPIRED: window.cartCouponWarningText.expired,
  };

  if (!discountCode || discountCode.trim() === "") return true;

  if (discountCode && discountCode.trim() !== "") {
    discountCode = discountCode.trim();
    const codes = discountCode.split(",").map((c) => c.trim());
    const lastCode = codes[codes.length - 1];

    try {
      // Original Boba coupon logic
      const separatorPattern =
        window.bobaUtils?.couponCodeSeparator || "[-_XX]";
      const separatorRegex = new RegExp(separatorPattern);
      const isBobaCoupon =
        !lastCode.toLowerCase().includes("bogo") &&
        separatorRegex.test(lastCode) &&
        /^\d+$/.test(lastCode.split(separatorRegex).pop());

      console.log("[CouponScript] Is Boba:", isBobaCoupon);

      if (isBobaCoupon) {
        console.log("Verifying Boba coupon:", lastCode);
        const result = await window.bobaUtils.verifyCoupon(lastCode);
        console.log("Boba coupon verification result:", result);
        const now = new Date();

        // Coupon not redeemed / not found
        if (!result.successful) {
          showCouponError(COUPON_ERRORS.INVALID);
          const error = new Error("Invalid discount code");
          error.isDiscountError = true;
          return Promise.reject(error);
        }

        // Expired Date Check
        if (
          result.data.expirationDate &&
          new Date(result.data.expirationDate) < now
        ) {
          showCouponError(COUPON_ERRORS.INVALID);
          const error = new Error("Expired code");
          error.isDiscountError = true;
          return Promise.reject(error);
        }

        // Coupon expired
        if (result.data?.statusName == "expired") {
          showCouponError(COUPON_ERRORS.INVALID);
          const error = new Error("Expired code");
          error.isDiscountError = true;
          return Promise.reject(error);
        }

        // Used code
        if (result.data?.statusName == "used") {
          showCouponError(COUPON_ERRORS.INVALID);
          const error = new Error("Coupon already used");
          error.isDiscountError = true;
          return Promise.reject(error);
        }

        // Code is not active yet
        if (result.data?.startDate && new Date(result.data.startDate) > now) {
          showCouponError(COUPON_ERRORS.INVALID);
          const error = new Error("Inactive code");
          error.isDiscountError = true;
          return Promise.reject(error);
        }

        // Countdown coupon
        if (result.data?.statusName == "using-expired") {
          showCouponError(COUPON_ERRORS.INVALID);
          const error = new Error("Inactive code");
          error.isDiscountError = true;
          return Promise.reject(error);
        }
      }

      // Try Shopify discount first
      if (window.bobaUtils?.verifyShopifyDiscount) {
        console.log("Verifying Shopify discount code:", lastCode);
        const shopifyResult =
          await window.bobaUtils.verifyShopifyDiscount(lastCode);
        console.log("Shopify discount verification result:", shopifyResult);
        if (
          shopifyResult.error === "NOT_FOUND" ||
          shopifyResult.error === "NOT_APPLICABLE"
        ) {
          showCouponError(COUPON_ERRORS.INVALID);

          const error = new Error(
            shopifyResult.message || "Invalid discount code",
          );
          error.isDiscountError = true;
          return Promise.reject(error);
        }
      }

      return true;
    } catch (err) {
      console.error("Coupon verification failed:", err);
      showCouponError(COUPON_ERRORS.INVALID);
      const error = new Error("Coupon verification failed");
      error.isDiscountError = true;
      return false;
    }
  }
}

function handleApplyClick(e, applyBtn, input) {
  if (applyBtn.dataset.ignoreParams === "true") {
    applyBtn.dataset.ignoreParams = "false";
    return;
  }

  const code = input?.value || "";
  console.log("[CouponScript] Apply captured. Code:", code);

  if (!code) return;

  e.stopImmediatePropagation();
  e.preventDefault();

  let checkoutBtn = null;
  const shadow = applyBtn.getRootNode();
  if (shadow && typeof findCheckoutButton === "function") {
    checkoutBtn = findCheckoutButton(shadow);
  }

  if (checkoutBtn) {
    checkoutBtn.disabled = true;
    checkoutBtn.style.opacity = "0.5";
    checkoutBtn.style.cursor = "not-allowed";
  }

  verifyCouponLogic(code).then((isValid) => {
    if (checkoutBtn) {
      checkoutBtn.disabled = false;
      checkoutBtn.style.opacity = "";
      checkoutBtn.style.cursor = "";
    }

    if (isValid) {
      console.log("[CouponScript] Valid code. Re-triggering BOGOS.");
      applyBtn.dataset.ignoreParams = "true";
      applyBtn.dispatchEvent(
        new MouseEvent("click", {
          view: window,
          bubbles: true,
          cancelable: true,
        }),
      );
    } else {
      console.log("[CouponScript] Invalid code. BOGOS blocked.");
    }
  });
}

function attachClickListener(shadow) {
  const applyBtn = findApplyButton(shadow);
  const input = findDiscountInput(shadow);

  if (applyBtn && !applyBtn.dataset.couponIntercepted) {
    console.log("[CouponScript] Attaching click listener to:", applyBtn);
    applyBtn.addEventListener(
      "click",
      (e) => handleApplyClick(e, applyBtn, input),
      true,
    );
    applyBtn.dataset.couponIntercepted = "true";
  }
}

function observeShadowHost() {
  const hostId = "opus-shadow-container";
  const host = document.getElementById(hostId);

  if (host?.shadowRoot) {
    setupShadowObserver(host.shadowRoot);
    return;
  }

  console.log("[CouponScript] Waiting for shadow host...");
  const bodyObserver = new MutationObserver((mutations, obs) => {
    const h = document.getElementById(hostId);
    if (h?.shadowRoot) {
      console.log("[CouponScript] Shadow host found.");
      obs.disconnect();
      setupShadowObserver(h.shadowRoot);
    }
  });
  bodyObserver.observe(document.body, { childList: true, subtree: true });
}

function setupShadowObserver(shadowRoot) {
  console.log("[CouponScript] Setting up shadow observer.");

  attachClickListener(shadowRoot);

  const observer = new MutationObserver(() => attachClickListener(shadowRoot));
  observer.observe(shadowRoot, { childList: true, subtree: true });
}

observeShadowHost();
